import * as React from "react"

const MatahariUang1 = (props) => (
  <svg
    width={69}
    height={75}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M38.532 63.767c13.858 0 25.091-11.842 25.091-26.451 0-14.61-11.233-26.452-25.09-26.452-13.858 0-25.091 11.843-25.091 26.452 0 14.609 11.233 26.451 25.09 26.451Z"
      fill="#FFE600"
    />
    <path
      d="M25.539 43.929c1.485 0 2.688-1.27 2.688-2.835s-1.203-2.834-2.688-2.834-2.688 1.27-2.688 2.834c0 1.566 1.203 2.835 2.688 2.835ZM41.22 60.933c1.486 0 2.69-1.269 2.69-2.834 0-1.565-1.204-2.834-2.69-2.834-1.484 0-2.688 1.269-2.688 2.834 0 1.565 1.204 2.834 2.689 2.834Z"
      fill="#BCA11A"
      fillOpacity={0.6}
    />
    <path
      d="M37.412 31.175c.619 0 1.12-.529 1.12-1.18 0-.653-.501-1.182-1.12-1.182-.618 0-1.12.53-1.12 1.181 0 .652.502 1.181 1.12 1.181Z"
      fill="#BCA11A"
    />
    <path
      d="M37.86 4.724c.619 0 1.12-.53 1.12-1.181 0-.653-.501-1.181-1.12-1.181-.618 0-1.12.528-1.12 1.18 0 .653.502 1.182 1.12 1.182ZM40.549 2.362c.618 0 1.12-.529 1.12-1.181S41.167 0 40.549 0c-.619 0-1.12.529-1.12 1.18 0 .653.501 1.182 1.12 1.182ZM40.549 7.085c.618 0 1.12-.528 1.12-1.18 0-.653-.502-1.181-1.12-1.181-.619 0-1.12.528-1.12 1.18 0 .653.501 1.181 1.12 1.181ZM28.451 22.2c.619 0 1.12-.528 1.12-1.18 0-.653-.501-1.181-1.12-1.181-.618 0-1.12.528-1.12 1.18 0 .653.502 1.182 1.12 1.182Z"
      fill="#E57E1F"
    />
    <path
      d="M49.734 31.175c1.484 0 2.688-1.269 2.688-2.834 0-1.565-1.203-2.834-2.688-2.834s-2.689 1.269-2.689 2.834c0 1.565 1.204 2.834 2.689 2.834Z"
      fill="#E67E1F"
    />
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={3}
      y={24}
      width={20}
      height={24}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.834 43.445c4.892-2.373 7.073-8.387 4.87-13.433-2.202-5.045-7.953-7.211-12.846-4.838-4.892 2.374-7.073 8.388-4.87 13.433.985 2.258 2.68 3.938 4.692 4.894l.3 3.257a.666.666 0 0 0 1.18.38l2.302-2.73.002-.003a9.455 9.455 0 0 0 4.37-.96Z"
        fill="#fff"
      />
    </mask>
    <mask
      id="b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={65}
      y={35}
      width={4}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.132 38.93a1.613 1.613 0 0 0 .768-2.08 1.464 1.464 0 0 0-1.998-.738 1.614 1.614 0 0 0-.767 2.08c.151.348.414.606.727.753l.045.503c.008.094.122.13.183.058l.361-.424c.227.004.46-.044.681-.152Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.132 38.93a1.613 1.613 0 0 0 .768-2.08 1.464 1.464 0 0 0-1.998-.738 1.614 1.614 0 0 0-.767 2.08c.152.348.415.606.727.753l.045.503c.008.094.122.13.183.058l.361-.424c.227.004.46-.044.681-.152Z"
        fill="#F2C94C"
      />
      <path
        d="m65.862 38.945.106-.013-.006-.061-.054-.026-.046.1Zm.045.503-.105.013.105-.013Zm.183.058.08.07-.08-.07Zm.361-.424.079.07-.079-.07Zm0 0 .005-.11h-.05l-.034.04.08.07Zm1.353-2.185a1.5 1.5 0 0 1-.715 1.935l.087.196a1.726 1.726 0 0 0 .82-2.225l-.192.094Zm-1.859-.687a1.362 1.362 0 0 1 1.859.687l.193-.094a1.567 1.567 0 0 0-2.137-.79l.085.197Zm-.714 1.935a1.501 1.501 0 0 1 .714-1.935l-.085-.197a1.726 1.726 0 0 0-.822 2.226l.193-.094Zm.677.7a1.372 1.372 0 0 1-.677-.7l-.193.093c.163.373.444.65.779.806l.091-.198Zm.104.59-.044-.503-.211.026.045.503.21-.026Zm0 0-.21.026c.016.188.244.26.367.115l-.157-.14Zm.36-.424-.36.424.157.141.36-.423-.157-.142Zm0 0 .157.142v-.001l-.157-.14Zm.718-.18c-.207.101-.423.146-.634.142l-.01.218c.243.004.493-.048.73-.163l-.087-.196Z"
        fill="#F9A33D"
      />
      <path
        d="M66.957 38.529c.547-.265.793-.931.55-1.488a1.047 1.047 0 0 0-1.43-.528c-.546.265-.791.93-.549 1.488.243.556.883.793 1.43.528Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.825 37.685a.226.226 0 0 1-.121.286.205.205 0 0 1-.274-.118l-.099.041a.308.308 0 0 0 .41.177.338.338 0 0 0 .183-.428.298.298 0 0 0-.12-.145.465.465 0 0 0-.227-.066l-.002-.011a.568.568 0 0 1-.046.01h-.028v.003c-.184.022-.284-.065-.31-.105a.226.226 0 0 1 .063-.304.206.206 0 0 1 .294.057l.088-.061a.308.308 0 0 0-.439-.086.338.338 0 0 0-.094.455c.049.077.195.186.431.15a.39.39 0 0 1 .212.05c.047.03.069.068.08.095Z"
        fill="#F9A33D"
      />
      <path
        d="m66.21 36.816-.07.034.062.14.07-.033-.062-.14ZM66.802 37.98l-.07.034.062.141.07-.034-.062-.14Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="c"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={60}
      y={40}
      width={4}
      height={4}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.1 43.242a1.613 1.613 0 0 0 .767-2.08 1.464 1.464 0 0 0-1.997-.738 1.614 1.614 0 0 0-.768 2.08c.152.348.415.606.728.753l.045.503c.008.094.121.13.183.058l.36-.424c.228.004.46-.044.682-.152Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#c)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.1 43.242a1.613 1.613 0 0 0 .767-2.08 1.464 1.464 0 0 0-1.997-.738 1.614 1.614 0 0 0-.768 2.08c.152.348.415.607.728.753l.045.503c.008.094.121.13.183.058l.36-.424c.228.004.46-.044.682-.152Z"
        fill="#F2C94C"
      />
      <path
        d="m61.83 43.257.105-.013-.006-.061-.053-.026-.046.1Zm.045.503-.106.013.106-.013Zm.183.058.079.07-.08-.07Zm.36-.424.079.07-.078-.07Zm0 0 .005-.11h-.05l-.033.04.078.07Zm1.353-2.185a1.5 1.5 0 0 1-.714 1.935l.086.196a1.726 1.726 0 0 0 .821-2.225l-.193.094Zm-1.858-.687a1.362 1.362 0 0 1 1.858.687l.193-.094a1.567 1.567 0 0 0-2.137-.79l.086.197Zm-.714 1.935a1.501 1.501 0 0 1 .714-1.935l-.086-.197a1.726 1.726 0 0 0-.821 2.225l.193-.093Zm.677.7a1.372 1.372 0 0 1-.677-.7l-.193.093c.162.373.444.65.778.806l.092-.199Zm.103.59-.044-.503-.21.026.044.503.21-.026Zm0 0-.21.026c.017.188.245.26.368.115l-.158-.14Zm.36-.423-.36.423.158.141.36-.423-.157-.142Zm0 0 .158.14-.157-.14Zm.718-.18c-.206.1-.422.145-.634.14l-.009.218c.243.005.492-.047.729-.162l-.086-.196Z"
        fill="#F9A33D"
      />
      <path
        d="M62.925 42.84c.546-.264.792-.93.549-1.487a1.047 1.047 0 0 0-1.43-.528 1.154 1.154 0 0 0-.548 1.488c.243.556.883.793 1.429.528Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.793 41.997a.226.226 0 0 1-.122.286.205.205 0 0 1-.274-.118l-.099.042a.308.308 0 0 0 .411.176.339.339 0 0 0 .182-.428.298.298 0 0 0-.12-.145.463.463 0 0 0-.227-.066l-.002-.011a.617.617 0 0 1-.046.01h-.027v.003c-.185.022-.285-.065-.31-.105a.226.226 0 0 1 .063-.304.206.206 0 0 1 .293.057l.089-.061a.308.308 0 0 0-.44-.086.339.339 0 0 0-.094.455c.05.077.195.186.432.15a.39.39 0 0 1 .212.05c.047.03.068.068.079.095Z"
        fill="#F9A33D"
      />
      <path
        d="m62.178 41.128-.07.034.062.14.069-.033-.061-.14ZM62.77 42.293l-.07.033.062.141.069-.033-.062-.141Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="d"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={65}
      y={39}
      width={4}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.132 42.77a1.613 1.613 0 0 0 .768-2.08 1.464 1.464 0 0 0-1.998-.739 1.614 1.614 0 0 0-.767 2.08c.151.349.414.607.727.753l.045.504c.008.094.122.13.183.057l.361-.423c.227.004.46-.045.681-.152Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#d)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.132 42.77a1.613 1.613 0 0 0 .768-2.08 1.465 1.465 0 0 0-1.998-.739 1.614 1.614 0 0 0-.767 2.08c.152.349.415.607.727.753l.045.504c.008.094.122.13.183.057l.361-.423c.227.004.46-.045.681-.152Z"
        fill="#F2C94C"
      />
      <path
        d="m65.862 42.784.106-.012-.006-.062-.054-.025-.046.1Zm.045.504-.105.012.105-.012Zm.183.057.08.071-.08-.07Zm.361-.423.079.07-.079-.07Zm0 0 .005-.11h-.05l-.034.04.08.07Zm1.353-2.185a1.5 1.5 0 0 1-.715 1.934l.087.197a1.726 1.726 0 0 0 .82-2.225l-.192.093Zm-1.859-.687a1.362 1.362 0 0 1 1.859.687l.193-.094a1.567 1.567 0 0 0-2.137-.79l.085.197Zm-.714 1.935a1.501 1.501 0 0 1 .714-1.935l-.085-.197a1.726 1.726 0 0 0-.822 2.225l.193-.093Zm.677.7a1.372 1.372 0 0 1-.677-.7l-.193.093c.163.372.444.65.779.806l.091-.199Zm.104.59-.044-.503-.211.025.045.503.21-.025Zm0 0-.21.025c.016.189.244.26.367.116l-.157-.141Zm.36-.424-.36.424.157.141.36-.424-.157-.14Zm0 0 .157.141-.157-.14Zm.718-.18c-.207.1-.423.146-.634.142l-.01.217c.243.005.493-.047.73-.162l-.087-.197Z"
        fill="#F9A33D"
      />
      <path
        d="M66.957 42.368c.547-.265.793-.93.55-1.487a1.047 1.047 0 0 0-1.43-.528c-.546.265-.791.93-.549 1.487.243.557.883.793 1.43.528Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.825 41.525a.226.226 0 0 1-.121.285.205.205 0 0 1-.274-.117l-.099.041a.308.308 0 0 0 .41.177.338.338 0 0 0 .183-.428.298.298 0 0 0-.12-.146.465.465 0 0 0-.227-.066l-.002-.01a.613.613 0 0 1-.046.009h-.028v.004c-.184.022-.284-.065-.31-.105a.226.226 0 0 1 .063-.304.206.206 0 0 1 .294.057l.088-.061a.308.308 0 0 0-.439-.086.338.338 0 0 0-.094.455c.049.077.195.186.431.149.103 0 .17.024.212.051.047.03.069.068.08.095Z"
        fill="#F9A33D"
      />
      <path
        d="m66.21 40.656-.07.033.062.141.07-.033-.062-.141ZM66.802 41.82l-.07.034.062.14.07-.033-.062-.14Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={60}
      y={36}
      width={4}
      height={4}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.1 38.99a1.613 1.613 0 0 0 .767-2.08 1.464 1.464 0 0 0-1.997-.738 1.614 1.614 0 0 0-.768 2.08c.152.349.415.607.728.754l.045.503c.008.094.121.13.183.058l.36-.424c.228.004.46-.045.682-.152Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#e)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.1 38.99a1.613 1.613 0 0 0 .767-2.08 1.464 1.464 0 0 0-1.997-.737 1.614 1.614 0 0 0-.768 2.08c.152.348.415.606.728.753l.045.503c.008.094.121.13.183.058l.36-.424c.228.004.46-.044.682-.152Z"
        fill="#F2C94C"
      />
      <path
        d="m61.83 39.006.105-.013-.006-.061-.053-.026-.046.1Zm.045.503-.106.012.106-.012Zm.183.058.079.07-.08-.07Zm.36-.424.079.07-.078-.07Zm0 0 .005-.11h-.05l-.033.04.078.07Zm1.353-2.185a1.5 1.5 0 0 1-.714 1.935l.086.196a1.726 1.726 0 0 0 .821-2.225l-.193.094Zm-1.858-.687a1.362 1.362 0 0 1 1.858.687l.193-.094a1.567 1.567 0 0 0-2.137-.79l.086.197Zm-.714 1.935a1.501 1.501 0 0 1 .714-1.935l-.086-.197a1.726 1.726 0 0 0-.821 2.225l.193-.093Zm.677.7a1.372 1.372 0 0 1-.677-.7l-.193.093c.162.373.444.65.778.806l.092-.199Zm.103.59-.044-.503-.21.025.044.503.21-.025Zm0 0-.21.025c.017.19.245.26.368.116l-.158-.14Zm.36-.424-.36.424.158.141.36-.423-.157-.142Zm0 0 .158.141-.157-.14Zm.718-.18c-.206.1-.422.146-.634.142l-.009.217c.243.005.492-.047.729-.162l-.086-.196Z"
        fill="#F9A33D"
      />
      <path
        d="M62.925 38.59c.546-.265.792-.931.549-1.488a1.047 1.047 0 0 0-1.43-.528 1.154 1.154 0 0 0-.548 1.488c.243.556.883.793 1.429.528Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.793 37.746a.226.226 0 0 1-.122.286.205.205 0 0 1-.274-.118l-.099.041a.308.308 0 0 0 .411.177.339.339 0 0 0 .182-.428.298.298 0 0 0-.12-.145.465.465 0 0 0-.227-.066l-.002-.012a.57.57 0 0 1-.046.01h-.027v.004c-.185.022-.285-.065-.31-.105a.226.226 0 0 1 .063-.304.206.206 0 0 1 .293.057l.089-.061a.308.308 0 0 0-.44-.086.339.339 0 0 0-.094.455c.05.077.195.186.432.149.103 0 .17.024.212.051.047.03.068.068.079.095Z"
        fill="#F9A33D"
      />
      <path
        d="m62.178 36.877-.07.034.062.14.069-.033-.061-.14ZM62.77 38.041l-.07.034.062.14.069-.033-.062-.14Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="f"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={20}
      y={61}
      width={3}
      height={3}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.727 62.919a.914.914 0 0 0 .435-1.179.83.83 0 0 0-1.132-.419.914.914 0 0 0-.435 1.179.834.834 0 0 0 .413.427l.025.285c.005.053.07.073.104.032l.204-.24a.845.845 0 0 0 .386-.085Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#f)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.727 62.92a.914.914 0 0 0 .434-1.18.83.83 0 0 0-1.132-.418.914.914 0 0 0-.434 1.179.835.835 0 0 0 .412.426l.025.286c.005.053.07.073.104.032l.204-.24a.846.846 0 0 0 .387-.086Z"
        fill="#F2C94C"
      />
      <path
        d="m21.008 62.927.06-.008-.004-.034-.03-.015-.026.057Zm.025.285-.06.007.06-.007Zm.104.032.044.04-.044-.04Zm.204-.24.045.04-.045-.04Zm0 0 .003-.061h-.029l-.018.021.044.04Zm.767-1.237a.85.85 0 0 1-.405 1.096l.049.111a.978.978 0 0 0 .465-1.26l-.11.053Zm-1.053-.39a.772.772 0 0 1 1.053.39l.109-.053a.888.888 0 0 0-1.211-.448l.049.111Zm-.405 1.097a.85.85 0 0 1 .405-1.097l-.049-.111a.978.978 0 0 0-.465 1.26l.109-.052Zm.384.396a.776.776 0 0 1-.384-.396l-.11.053a.893.893 0 0 0 .442.456l.052-.113Zm.058.335-.025-.285-.119.014.025.285.12-.014Zm0 0-.119.014c.01.107.139.147.208.066l-.089-.08Zm.205-.24-.205.24.09.08.204-.24-.09-.08Zm0 0 .089.08-.09-.08Zm.406-.102a.785.785 0 0 1-.36.08l-.004.123a.908.908 0 0 0 .413-.092l-.049-.111Z"
        fill="#F9A33D"
      />
      <path
        d="M21.628 62.69a.654.654 0 0 0 .311-.842.593.593 0 0 0-.81-.299.653.653 0 0 0-.31.843c.137.315.5.45.809.299Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.553 62.213a.128.128 0 0 1-.069.162.116.116 0 0 1-.155-.067l-.056.024c.036.094.14.14.233.1a.192.192 0 0 0 .103-.243.168.168 0 0 0-.068-.082.263.263 0 0 0-.128-.038l-.002-.006a.348.348 0 0 1-.026.006h-.015v.002c-.105.012-.162-.037-.176-.06a.128.128 0 0 1 .036-.172.117.117 0 0 1 .166.032l.05-.034a.174.174 0 0 0-.249-.049.191.191 0 0 0-.053.258c.028.044.11.105.244.084a.22.22 0 0 1 .12.03.111.111 0 0 1 .045.053Z"
        fill="#F9A33D"
      />
      <path
        d="m21.204 61.72-.039.02.035.08.04-.02-.035-.08ZM21.54 62.38l-.04.02.036.08.039-.02-.035-.08Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="g"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={19}
      y={64}
      width={3}
      height={3}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 65.771a.914.914 0 0 0 .436-1.178.83.83 0 0 0-1.132-.419.914.914 0 0 0-.435 1.179.837.837 0 0 0 .412.427l.025.284c.005.054.07.074.104.033l.205-.24a.848.848 0 0 0 .386-.086Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#g)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 65.772a.914.914 0 0 0 .435-1.179.83.83 0 0 0-1.132-.418.914.914 0 0 0-.435 1.178.837.837 0 0 0 .412.427l.026.285c.004.054.069.074.104.033l.204-.24a.846.846 0 0 0 .386-.086Z"
        fill="#F2C94C"
      />
      <path
        d="m20.281 65.78.06-.008-.003-.035-.031-.014-.026.056Zm.025.284-.06.008.06-.008Zm.104.033.045.04-.045-.04Zm.205-.24.044.04-.044-.04Zm0 0 .002-.062h-.028l-.019.022.045.04Zm.766-1.238a.85.85 0 0 1-.404 1.096l.048.112a.978.978 0 0 0 .465-1.26l-.109.052Zm-1.053-.39a.772.772 0 0 1 1.053.39l.11-.053a.887.887 0 0 0-1.212-.447l.05.11Zm-.404 1.097a.85.85 0 0 1 .404-1.096l-.049-.111a.978.978 0 0 0-.465 1.26l.11-.053Zm.383.397a.776.776 0 0 1-.383-.397l-.11.053a.895.895 0 0 0 .441.457l.052-.113Zm.059.334-.025-.285-.12.015.026.284.119-.014Zm0 0-.12.014c.01.108.14.148.209.066l-.09-.08Zm.204-.24-.204.24.089.08.204-.24-.089-.08Zm0 0 .09.08-.09-.08Zm.407-.102a.785.785 0 0 1-.36.08l-.005.123a.901.901 0 0 0 .413-.091l-.048-.112Z"
        fill="#F9A33D"
      />
      <path
        d="M20.901 65.543a.654.654 0 0 0 .312-.842.594.594 0 0 0-.81-.3.654.654 0 0 0-.311.843c.138.316.5.45.81.3Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.827 65.065a.128.128 0 0 1-.07.162.116.116 0 0 1-.155-.066l-.055.023c.035.095.14.14.232.1a.192.192 0 0 0 .104-.242.168.168 0 0 0-.069-.082.263.263 0 0 0-.128-.038l-.001-.006a.324.324 0 0 1-.026.005h-.016v.003c-.104.012-.161-.038-.175-.06a.127.127 0 0 1 .035-.172.117.117 0 0 1 .166.032l.05-.035a.175.175 0 0 0-.248-.048.191.191 0 0 0-.054.258c.028.043.111.105.245.084.058 0 .096.013.12.029a.11.11 0 0 1 .045.053Z"
        fill="#F9A33D"
      />
      <path
        d="m20.478 64.573-.04.02.036.08.039-.02-.035-.08ZM20.814 65.233l-.04.019.035.08.04-.02-.035-.079Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={22}
      y={63}
      width={2}
      height={3}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.326 65.159a.915.915 0 0 0 .434-1.18.83.83 0 0 0-1.131-.418.915.915 0 0 0-.435 1.179.835.835 0 0 0 .412.427l.025.285c.005.053.07.073.104.032l.204-.24a.847.847 0 0 0 .387-.085Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#h)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.325 65.16a.915.915 0 0 0 .435-1.18.83.83 0 0 0-1.132-.418.915.915 0 0 0-.435 1.179.835.835 0 0 0 .412.426l.025.286c.005.053.07.073.105.032l.204-.24a.847.847 0 0 0 .386-.086Z"
        fill="#F2C94C"
      />
      <path
        d="m22.606 65.166.06-.007-.004-.034-.03-.015-.026.056Zm.025.286-.06.007.06-.007Zm.104.032.045.04-.045-.04Zm.204-.24.045.04-.045-.04Zm0 0 .003-.061-.028-.001-.02.022.046.04Zm.767-1.238a.85.85 0 0 1-.405 1.097l.049.111a.978.978 0 0 0 .465-1.26l-.11.052Zm-1.053-.389a.772.772 0 0 1 1.053.39l.11-.054a.888.888 0 0 0-1.212-.447l.049.111Zm-.405 1.096a.85.85 0 0 1 .405-1.096l-.049-.111a.978.978 0 0 0-.465 1.26l.11-.053Zm.384.397a.777.777 0 0 1-.384-.397l-.109.053a.893.893 0 0 0 .441.457l.052-.113Zm.059.335-.026-.286-.119.015.026.285.119-.014Zm0 0-.12.014c.01.107.139.147.209.066l-.09-.08Zm.204-.24-.204.24.089.08.204-.24-.09-.08Zm0 0 .089.08-.09-.08Zm.406-.102a.785.785 0 0 1-.359.08l-.005.123a.908.908 0 0 0 .413-.092l-.049-.111Z"
        fill="#F9A33D"
      />
      <path
        d="M23.226 64.93a.653.653 0 0 0 .311-.842.593.593 0 0 0-.81-.299.653.653 0 0 0-.31.843c.137.315.5.449.81.299Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.151 64.453a.128.128 0 0 1-.068.162.116.116 0 0 1-.156-.067l-.056.024c.036.094.14.14.233.1a.192.192 0 0 0 .103-.243.167.167 0 0 0-.068-.082.264.264 0 0 0-.128-.038l-.002-.006a.277.277 0 0 1-.025.006h-.016v.002c-.105.012-.161-.037-.176-.06a.128.128 0 0 1 .036-.172.117.117 0 0 1 .166.032l.05-.034a.174.174 0 0 0-.248-.049.191.191 0 0 0-.054.258c.028.043.11.105.245.084a.22.22 0 0 1 .12.03.112.112 0 0 1 .044.053Z"
        fill="#F9A33D"
      />
      <path
        d="m22.803 63.96-.04.02.035.08.04-.02-.035-.08ZM23.138 64.62l-.039.02.035.08.04-.02-.036-.08Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="i"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={18}
      y={61}
      width={2}
      height={3}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.402 63.627a.914.914 0 0 0 .435-1.179.83.83 0 0 0-1.131-.418.914.914 0 0 0-.435 1.178.834.834 0 0 0 .412.427l.025.285c.005.053.07.074.104.032l.204-.24a.848.848 0 0 0 .387-.085Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#i)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.402 63.627a.914.914 0 0 0 .435-1.178.83.83 0 0 0-1.132-.419.914.914 0 0 0-.435 1.179.835.835 0 0 0 .412.426l.025.286c.005.053.07.074.104.032l.204-.24a.846.846 0 0 0 .387-.086Z"
        fill="#F2C94C"
      />
      <path
        d="m18.683 63.635.06-.007-.004-.035-.03-.015-.026.057Zm.025.285-.06.007.06-.007Zm.104.032.045.04-.045-.04Zm.204-.24.045.04-.045-.04Zm0 0 .003-.061h-.028l-.02.022.046.04Zm.767-1.238a.85.85 0 0 1-.405 1.097l.049.111a.978.978 0 0 0 .465-1.26l-.11.053Zm-1.053-.389a.772.772 0 0 1 1.053.39l.11-.053a.888.888 0 0 0-1.212-.448l.049.111Zm-.405 1.097a.85.85 0 0 1 .405-1.097l-.049-.111a.978.978 0 0 0-.465 1.26l.11-.052Zm.384.396a.776.776 0 0 1-.384-.396l-.11.053a.896.896 0 0 0 .442.456l.052-.113Zm.059.335-.026-.285-.119.014.026.285.119-.014Zm0 0-.12.014c.01.107.139.148.209.066l-.09-.08Zm.204-.24-.204.24.089.08.204-.24-.09-.08Zm0 0 .089.08-.09-.08Zm.406-.102a.785.785 0 0 1-.359.08l-.005.123a.9.9 0 0 0 .413-.092l-.049-.111Z"
        fill="#F9A33D"
      />
      <path
        d="M19.303 63.399a.653.653 0 0 0 .311-.843.594.594 0 0 0-.81-.299.654.654 0 0 0-.31.843c.137.316.5.45.81.299Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.228 62.92a.128.128 0 0 1-.069.163.116.116 0 0 1-.155-.067l-.056.024c.036.094.14.14.233.1a.192.192 0 0 0 .103-.243.168.168 0 0 0-.068-.082.263.263 0 0 0-.128-.037l-.002-.007a.313.313 0 0 1-.025.006h-.016v.002c-.105.012-.161-.037-.176-.06a.128.128 0 0 1 .036-.172.116.116 0 0 1 .166.032l.05-.034a.174.174 0 0 0-.248-.049.191.191 0 0 0-.054.258c.028.044.11.105.245.085.058 0 .096.013.12.029a.11.11 0 0 1 .044.053Z"
        fill="#F9A33D"
      />
      <path
        d="m18.88 62.429-.04.02.035.079.04-.02-.035-.08ZM19.215 63.089l-.039.019.035.08.039-.02-.035-.08Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="j"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={48}
      width={5}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.081 51.69a1.833 1.833 0 0 0 .872-2.364 1.665 1.665 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.051.572c.01.107.139.148.209.066l.41-.482c.258.005.522-.05.774-.173Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#j)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.081 51.69a1.833 1.833 0 0 0 .872-2.364 1.665 1.665 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.051.572c.01.107.139.148.209.066l.41-.482c.258.005.522-.05.774-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m6.637 51.706.12-.014-.006-.07-.062-.029-.052.113Zm.051.572-.12.014.12-.014Zm.209.066.09.08-.09-.08Zm.41-.482.089.08-.09-.08Zm0 0 .005-.124-.057-.001-.038.045.09.08Zm1.537-2.483a1.706 1.706 0 0 1-.812 2.199l.098.223a1.962 1.962 0 0 0 .933-2.529l-.22.107Zm-2.112-.781a1.549 1.549 0 0 1 2.112.78l.219-.106a1.78 1.78 0 0 0-2.429-.897l.098.223Zm-.812 2.199a1.706 1.706 0 0 1 .812-2.2l-.098-.222a1.961 1.961 0 0 0-.933 2.528l.219-.106Zm.77.796a1.56 1.56 0 0 1-.77-.796l-.22.106c.186.424.505.738.886.916l.103-.226Zm.118.67-.051-.571-.239.029.05.572.24-.03Zm0 0-.24.03a.235.235 0 0 0 .418.13l-.178-.16Zm.41-.481-.41.482.178.16.41-.481-.179-.161Zm0 0h-.001l.179.16-.179-.16Zm.814-.204c-.234.114-.48.165-.72.16l-.01.248c.275.005.558-.054.828-.185l-.098-.223Z"
        fill="#F9A33D"
      />
      <path
        d="M7.882 51.233c.62-.3.9-1.058.624-1.69a1.19 1.19 0 0 0-1.624-.6c-.62.3-.9 1.058-.624 1.69a1.19 1.19 0 0 0 1.624.6Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.732 50.274a.257.257 0 0 1-.138.325.233.233 0 0 1-.312-.134l-.112.048c.072.19.28.28.467.2a.385.385 0 0 0 .207-.486.339.339 0 0 0-.137-.165.523.523 0 0 0-.257-.075l-.003-.013a.628.628 0 0 1-.052.011h-.031v.004c-.21.025-.324-.074-.353-.12a.256.256 0 0 1 .072-.345.234.234 0 0 1 .333.065l.101-.07a.35.35 0 0 0-.499-.097.384.384 0 0 0-.107.517c.055.088.222.212.49.17a.44.44 0 0 1 .241.058.22.22 0 0 1 .09.107Z"
        fill="#F9A33D"
      />
      <path
        d="m7.032 49.287-.078.038.07.16.078-.038-.07-.16ZM7.705 50.61l-.078.038.07.16.078-.037-.07-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={4}
      y={54}
      width={4}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.624 57.411a1.834 1.834 0 0 0 .872-2.363 1.665 1.665 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.05.572c.01.107.14.148.21.066l.409-.482c.258.005.523-.05.775-.173Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#k)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.624 57.411a1.833 1.833 0 0 0 .872-2.363 1.665 1.665 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.05.572c.01.107.14.148.21.066l.409-.482c.258.005.523-.05.775-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m5.18 57.428.12-.014-.007-.07-.061-.029-.052.113Zm.05.572-.119.015.12-.015Zm.21.066.089.08-.09-.08Zm.409-.482.09.08-.09-.08Zm0 0 .006-.124h-.057l-.038.044.09.08ZM7.387 55.1a1.706 1.706 0 0 1-.812 2.199l.097.223a1.962 1.962 0 0 0 .934-2.529l-.22.107Zm-2.113-.78a1.548 1.548 0 0 1 2.113.78l.219-.107a1.78 1.78 0 0 0-2.43-.897l.098.223Zm-.811 2.198a1.705 1.705 0 0 1 .811-2.199l-.097-.223a1.961 1.961 0 0 0-.933 2.528l.219-.106Zm.769.797a1.56 1.56 0 0 1-.77-.797l-.218.106c.184.424.504.738.884.916l.104-.225Zm.118.67-.05-.572-.24.029.051.572.24-.03Zm0 0-.239.029a.235.235 0 0 0 .418.13l-.179-.16Zm.41-.482-.41.482.179.16.41-.481-.18-.161Zm0 0 .178.16h.001l-.18-.16Zm.815-.204c-.235.114-.48.165-.72.16l-.011.248c.276.005.56-.054.828-.185l-.097-.223Z"
        fill="#F9A33D"
      />
      <path
        d="M6.425 56.956c.62-.302.9-1.058.624-1.69a1.19 1.19 0 0 0-1.624-.601c-.62.301-.9 1.058-.624 1.69a1.19 1.19 0 0 0 1.624.6Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.275 55.996a.257.257 0 0 1-.139.325.233.233 0 0 1-.311-.134l-.112.048c.072.19.28.28.467.2a.385.385 0 0 0 .206-.486.339.339 0 0 0-.136-.165.528.528 0 0 0-.258-.075l-.002-.013a.761.761 0 0 1-.052.011h-.032v.005c-.21.024-.323-.075-.352-.12a.257.257 0 0 1 .072-.346.234.234 0 0 1 .333.065l.1-.07a.35.35 0 0 0-.498-.097.384.384 0 0 0-.108.517c.056.088.222.212.491.17.117 0 .192.027.24.058a.221.221 0 0 1 .09.107Z"
        fill="#F9A33D"
      />
      <path
        d="m5.575 55.009-.078.038.07.16.078-.037-.07-.161ZM6.248 56.333l-.079.038.07.16.079-.038-.07-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="l"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={8}
      y={52}
      width={5}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.287 56.182a1.833 1.833 0 0 0 .872-2.363 1.664 1.664 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.051.572c.01.107.139.148.209.066l.41-.482c.258.005.522-.05.774-.173Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#l)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.287 56.182a1.833 1.833 0 0 0 .872-2.363 1.665 1.665 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.051.572c.01.107.139.148.209.066l.41-.482c.258.005.522-.05.774-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m9.843 56.2.12-.015-.006-.07-.062-.029-.052.113Zm.051.57-.12.015.12-.014Zm.209.067.09.08-.09-.08Zm.41-.482.089.08-.09-.08Zm0 0 .005-.124h-.057l-.038.044.09.08Zm1.537-2.483a1.706 1.706 0 0 1-.812 2.199l.098.223a1.962 1.962 0 0 0 .933-2.529l-.22.107Zm-2.112-.78a1.548 1.548 0 0 1 2.112.78l.22-.107a1.78 1.78 0 0 0-2.43-.897l.098.223Zm-.812 2.198a1.705 1.705 0 0 1 .812-2.199l-.098-.223a1.961 1.961 0 0 0-.933 2.528l.219-.106Zm.77.797a1.56 1.56 0 0 1-.77-.797l-.22.106c.186.424.506.738.886.916l.103-.225Zm.118.67-.051-.572-.239.029.05.572.24-.03Zm0 0-.24.029a.235.235 0 0 0 .418.13l-.178-.16Zm.41-.482-.41.482.178.16.41-.482-.179-.16Zm0 0h-.001l.179.16-.179-.16Zm.814-.204c-.234.114-.48.165-.72.16l-.01.247c.275.006.559-.053.828-.184l-.098-.223Z"
        fill="#F9A33D"
      />
      <path
        d="M11.088 55.727c.62-.302.9-1.058.624-1.691a1.19 1.19 0 0 0-1.624-.6c-.62.301-.9 1.058-.624 1.69a1.19 1.19 0 0 0 1.624.6Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.938 54.767a.257.257 0 0 1-.138.325.233.233 0 0 1-.312-.134l-.112.048c.072.19.28.28.467.2a.385.385 0 0 0 .207-.486.338.338 0 0 0-.137-.165.528.528 0 0 0-.257-.075l-.003-.013a.822.822 0 0 1-.052.011h-.031v.005c-.21.024-.324-.075-.353-.12a.257.257 0 0 1 .072-.346.234.234 0 0 1 .333.065l.101-.07a.35.35 0 0 0-.499-.097.384.384 0 0 0-.107.517c.055.088.222.212.49.17.117 0 .193.027.241.058a.222.222 0 0 1 .09.107Z"
        fill="#F9A33D"
      />
      <path
        d="m10.238 53.78-.078.038.07.16.078-.037-.07-.161ZM10.911 55.103l-.078.039.07.16.078-.038-.07-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="m"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={49}
      width={5}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.418 53.11a1.834 1.834 0 0 0 .872-2.364 1.665 1.665 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.365c.173.396.472.69.827.856l.05.571c.01.107.14.148.21.066l.409-.482c.258.005.523-.05.775-.172Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#m)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.418 53.11a1.834 1.834 0 0 0 .872-2.364 1.665 1.665 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.365c.173.396.472.69.827.856l.05.571c.01.108.14.149.21.066l.409-.481c.258.004.523-.05.775-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m1.974 53.127.12-.015-.007-.07-.061-.028-.052.113Zm.05.571-.119.015.12-.015Zm.21.066.089.08-.09-.08Zm.409-.481.09.08-.09-.08Zm0 0 .006-.124-.057-.002-.038.045.09.08Zm1.538-2.484a1.706 1.706 0 0 1-.812 2.2l.097.223a1.962 1.962 0 0 0 .934-2.53l-.22.107Zm-2.113-.78a1.548 1.548 0 0 1 2.113.78l.219-.106a1.78 1.78 0 0 0-2.43-.898l.098.224Zm-.811 2.199a1.705 1.705 0 0 1 .811-2.2l-.097-.223a1.961 1.961 0 0 0-.933 2.529l.219-.106Zm.769.796a1.56 1.56 0 0 1-.77-.797l-.218.107c.184.423.504.738.884.916l.104-.226Zm.118.67-.05-.572-.24.029.051.572.24-.029Zm0 0-.239.029a.235.235 0 0 0 .418.131l-.179-.16Zm.41-.482-.41.482.179.16.41-.481-.18-.16Zm0 0 .178.16h.001l-.18-.16Zm.815-.204a1.58 1.58 0 0 1-.72.16l-.011.248c.276.005.56-.054.828-.184l-.097-.224Z"
        fill="#F9A33D"
      />
      <path
        d="M3.219 52.654c.62-.302.9-1.058.624-1.69a1.19 1.19 0 0 0-1.624-.601c-.62.301-.9 1.058-.624 1.69a1.19 1.19 0 0 0 1.624.6Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.069 51.695a.257.257 0 0 1-.139.325.234.234 0 0 1-.311-.134l-.112.047c.072.19.28.28.467.2a.385.385 0 0 0 .206-.486.339.339 0 0 0-.136-.165.528.528 0 0 0-.257-.075l-.003-.012a.766.766 0 0 1-.052.01l-.032.001v.004c-.21.025-.323-.074-.352-.12a.257.257 0 0 1 .072-.346.234.234 0 0 1 .333.066l.1-.07a.35.35 0 0 0-.498-.097.384.384 0 0 0-.108.517c.056.087.222.211.491.17.117 0 .192.027.24.057a.22.22 0 0 1 .09.108Z"
        fill="#F9A33D"
      />
      <path
        d="m2.37 50.708-.08.038.07.16.08-.038-.07-.16ZM3.042 52.03l-.079.04.07.16.079-.039-.07-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="n"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={13}
      y={6}
      width={5}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.146 9.65a1.834 1.834 0 0 0 .872-2.364 1.664 1.664 0 0 0-2.27-.839 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.051.572c.01.107.139.148.209.066l.41-.482c.258.005.522-.05.774-.173Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#n)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.146 9.65a1.834 1.834 0 0 0 .872-2.364 1.664 1.664 0 0 0-2.27-.839 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.051.572c.01.107.139.148.209.066l.41-.482c.258.005.522-.05.774-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m14.702 9.667.12-.014-.006-.07-.062-.029-.052.113Zm.051.572-.12.014.12-.014Zm.209.066.089.08-.09-.08Zm.41-.482.088.08-.089-.08Zm0 0 .005-.124-.057-.001-.038.045.09.08Zm1.537-2.484a1.706 1.706 0 0 1-.812 2.2l.098.223a1.962 1.962 0 0 0 .933-2.529l-.22.106Zm-2.112-.78a1.549 1.549 0 0 1 2.112.78l.219-.106a1.78 1.78 0 0 0-2.429-.897l.098.223Zm-.812 2.199a1.706 1.706 0 0 1 .812-2.2l-.098-.222a1.962 1.962 0 0 0-.933 2.528l.219-.106Zm.77.796a1.56 1.56 0 0 1-.77-.796l-.22.106c.185.423.505.738.885.916l.104-.226Zm.117.67-.05-.571-.239.028.05.572.24-.029Zm0 0-.238.03a.235.235 0 0 0 .417.13l-.178-.16Zm.41-.481-.41.481.179.16.41-.48-.179-.161Zm0 0 .179.16-.179-.16Zm.815-.204c-.234.113-.48.165-.72.16l-.01.247c.275.006.558-.053.828-.184l-.098-.223Z"
        fill="#F9A33D"
      />
      <path
        d="M15.947 9.194c.62-.301.9-1.058.624-1.69a1.19 1.19 0 0 0-1.624-.6c-.62.3-.9 1.057-.624 1.69a1.19 1.19 0 0 0 1.624.6Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.797 8.235a.257.257 0 0 1-.139.325.233.233 0 0 1-.311-.134l-.112.047c.072.19.28.28.467.201a.385.385 0 0 0 .207-.486.339.339 0 0 0-.137-.166.526.526 0 0 0-.257-.075l-.003-.012a.706.706 0 0 1-.052.01l-.031.001v.004c-.21.025-.324-.074-.353-.12a.256.256 0 0 1 .072-.345.234.234 0 0 1 .333.065l.101-.07a.35.35 0 0 0-.499-.097.384.384 0 0 0-.107.517c.055.088.221.212.49.17.117 0 .193.027.24.058a.22.22 0 0 1 .09.107Z"
        fill="#F9A33D"
      />
      <path
        d="m15.097 7.248-.078.038.07.16.078-.038-.07-.16ZM15.77 8.571l-.078.038.07.16.078-.038-.07-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="o"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={12}
      y={11}
      width={4}
      height={6}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.689 15.372a1.834 1.834 0 0 0 .872-2.364 1.664 1.664 0 0 0-2.27-.839 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.05.572c.01.107.14.148.21.066l.409-.482c.258.005.523-.05.775-.173Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#o)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.689 15.372a1.834 1.834 0 0 0 .872-2.364 1.664 1.664 0 0 0-2.27-.839 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.05.572c.01.107.14.148.21.066l.409-.482c.258.005.523-.05.775-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m13.245 15.389.12-.014-.007-.07-.061-.029-.052.113Zm.05.572-.119.014.12-.014Zm.21.066.089.08-.09-.08Zm.409-.482.09.08-.09-.08Zm0 0 .006-.124-.057-.001-.038.045.09.08Zm1.538-2.483a1.706 1.706 0 0 1-.812 2.199l.097.223a1.962 1.962 0 0 0 .934-2.529l-.22.107Zm-2.113-.781a1.549 1.549 0 0 1 2.113.78l.219-.106a1.78 1.78 0 0 0-2.43-.897l.098.223Zm-.811 2.2a1.706 1.706 0 0 1 .811-2.2l-.097-.223a1.961 1.961 0 0 0-.934 2.528l.22-.106Zm.769.795a1.56 1.56 0 0 1-.77-.796l-.218.106c.184.424.504.738.884.916l.104-.226Zm.118.67-.05-.571-.24.028.051.572.24-.028Zm0 0-.239.03a.235.235 0 0 0 .418.13l-.179-.16Zm.41-.481-.41.482.179.16.41-.482-.18-.16Zm0 0 .178.16-.178-.16Zm.815-.204c-.235.114-.48.165-.72.16l-.011.247c.276.006.56-.053.828-.184l-.097-.223Z"
        fill="#F9A33D"
      />
      <path
        d="M14.49 14.916c.62-.301.9-1.058.623-1.69a1.19 1.19 0 0 0-1.623-.6c-.621.3-.9 1.058-.624 1.69a1.19 1.19 0 0 0 1.624.6Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.34 13.957a.257.257 0 0 1-.139.325.233.233 0 0 1-.311-.134l-.112.047c.072.19.28.28.466.201a.385.385 0 0 0 .207-.486.339.339 0 0 0-.136-.165.527.527 0 0 0-.258-.076l-.002-.012a.668.668 0 0 1-.052.01l-.032.002v.003c-.21.025-.323-.074-.352-.12a.256.256 0 0 1 .072-.345.234.234 0 0 1 .333.065l.1-.07a.35.35 0 0 0-.498-.097.384.384 0 0 0-.108.517c.056.088.222.212.491.17.117 0 .192.027.24.058a.221.221 0 0 1 .09.107Z"
        fill="#F9A33D"
      />
      <path
        d="m13.64 12.97-.079.038.07.16.079-.038-.07-.16ZM14.313 14.293l-.079.038.07.16.079-.038-.07-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="p"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={16}
      y={10}
      width={5}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.352 14.143a1.834 1.834 0 0 0 .872-2.364 1.664 1.664 0 0 0-2.27-.839 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.051.572c.01.107.139.148.209.066l.41-.482c.258.005.522-.05.774-.173Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#p)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.352 14.143a1.834 1.834 0 0 0 .872-2.364 1.664 1.664 0 0 0-2.27-.839 1.834 1.834 0 0 0-.873 2.364c.173.396.472.69.827.856l.051.572c.01.107.139.148.209.066l.41-.482c.258.005.522-.05.774-.173Z"
        fill="#F2C94C"
      />
      <path
        d="m17.908 14.16.12-.014-.006-.07-.062-.029-.052.113Zm.051.572-.12.014.12-.014Zm.209.066.09.08-.09-.08Zm.41-.482.088.08-.089-.08Zm0 0 .005-.124-.057-.001-.038.045.09.08Zm1.537-2.484a1.706 1.706 0 0 1-.812 2.2l.098.223a1.962 1.962 0 0 0 .933-2.529l-.22.106Zm-2.112-.78a1.548 1.548 0 0 1 2.112.78l.219-.106a1.78 1.78 0 0 0-2.429-.897l.098.223Zm-.812 2.199a1.706 1.706 0 0 1 .812-2.2l-.098-.222a1.962 1.962 0 0 0-.933 2.528l.219-.106Zm.77.796a1.56 1.56 0 0 1-.77-.796l-.22.106c.186.424.506.738.886.916l.103-.226Zm.117.67-.05-.571-.239.028.05.572.24-.029Zm0 0-.238.03a.235.235 0 0 0 .417.13l-.179-.16Zm.41-.481-.41.481.18.16.409-.48-.179-.161Zm0 0 .178.16h.001l-.179-.16Zm.815-.204c-.234.114-.48.165-.72.16l-.01.247c.275.006.558-.053.828-.184l-.098-.223Z"
        fill="#F9A33D"
      />
      <path
        d="M19.153 13.687c.62-.301.9-1.058.624-1.69a1.19 1.19 0 0 0-1.624-.6c-.62.3-.9 1.057-.624 1.69a1.19 1.19 0 0 0 1.624.6Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.003 12.728a.257.257 0 0 1-.138.325.233.233 0 0 1-.312-.134l-.112.047c.072.19.28.28.467.201a.385.385 0 0 0 .207-.486.338.338 0 0 0-.137-.165.526.526 0 0 0-.257-.076l-.003-.012a.67.67 0 0 1-.052.01l-.031.002v.003c-.21.025-.324-.074-.353-.12a.256.256 0 0 1 .072-.345.234.234 0 0 1 .333.065l.101-.07a.35.35 0 0 0-.499-.097.384.384 0 0 0-.107.517c.055.088.222.211.49.17.117 0 .193.027.241.058a.22.22 0 0 1 .09.107Z"
        fill="#F9A33D"
      />
      <path
        d="m18.303 11.741-.078.038.07.16.078-.038-.07-.16ZM18.976 13.064l-.078.038.07.16.078-.038-.07-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="q"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={9}
      y={7}
      width={4}
      height={5}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.483 11.07a1.834 1.834 0 0 0 .872-2.363 1.665 1.665 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.365c.173.395.472.69.827.855l.05.572c.01.107.14.148.21.066l.409-.482c.258.005.523-.05.775-.172Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#q)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.483 11.07a1.834 1.834 0 0 0 .872-2.363 1.665 1.665 0 0 0-2.27-.84 1.834 1.834 0 0 0-.873 2.365c.173.395.472.69.827.855l.05.572c.01.107.14.148.21.066l.409-.482c.258.005.523-.05.775-.172Z"
        fill="#F2C94C"
      />
      <path
        d="m10.04 11.088.119-.015-.007-.07-.061-.028-.052.113Zm.05.571-.12.015.12-.015Zm.208.066.09.08-.09-.08Zm.41-.482.09.08-.09-.08Zm0 0 .006-.124h-.057l-.038.044.09.08Zm1.537-2.483a1.706 1.706 0 0 1-.811 2.2l.097.222a1.962 1.962 0 0 0 .934-2.528l-.22.106Zm-2.112-.78a1.548 1.548 0 0 1 2.113.78l.219-.106a1.78 1.78 0 0 0-2.43-.898l.098.223Zm-.811 2.198a1.706 1.706 0 0 1 .811-2.199l-.097-.223a1.962 1.962 0 0 0-.934 2.529l.22-.107Zm.769.797a1.56 1.56 0 0 1-.77-.796l-.219.106c.185.423.505.738.885.915l.104-.225Zm.118.67-.05-.572-.24.029.051.572.24-.03Zm0 0-.239.029a.235.235 0 0 0 .418.131l-.179-.16Zm.41-.482-.41.482.179.16.41-.481-.18-.16Zm0 0 .178.16-.178-.16Zm.815-.204c-.235.114-.48.165-.72.16l-.011.248c.276.005.56-.054.828-.185l-.097-.223Z"
        fill="#F9A33D"
      />
      <path
        d="M11.284 10.614c.62-.3.9-1.057.623-1.69a1.19 1.19 0 0 0-1.623-.6c-.621.301-.9 1.058-.624 1.69a1.19 1.19 0 0 0 1.623.6Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.133 9.656a.257.257 0 0 1-.138.325.233.233 0 0 1-.311-.135l-.112.048c.072.19.28.28.466.2a.385.385 0 0 0 .207-.486.338.338 0 0 0-.136-.165.527.527 0 0 0-.258-.075l-.002-.013a.704.704 0 0 1-.052.011h-.032v.005c-.21.025-.323-.075-.352-.12a.256.256 0 0 1 .072-.346.234.234 0 0 1 .333.066l.1-.07a.35.35 0 0 0-.498-.098.384.384 0 0 0-.108.518c.056.087.222.211.49.169.118 0 .193.027.242.058a.22.22 0 0 1 .09.108Z"
        fill="#F9A33D"
      />
      <path
        d="m10.434 8.668-.079.039.07.16.079-.038-.07-.16ZM11.107 9.992l-.079.038.07.16.079-.038-.07-.16Z"
        fill="#F9A33D"
      />
    </g>
    <mask
      id="r"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={38}
      y={44}
      width={21}
      height={23}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.07 64.889c5.327-.83 9.023-5.956 8.253-11.451-.77-5.495-5.712-9.277-11.04-8.448-5.328.83-9.023 5.956-8.253 11.45.344 2.46 1.523 4.575 3.2 6.088l-.58 3.214c-.109.603.53 1.046 1.032.714l2.935-1.938.003-.002a9.398 9.398 0 0 0 4.45.373Z"
        fill="#fff"
      />
    </mask>
    <path
      d="M36 74.5c-4.4.8-25-2.5-34-4.5 16-1.5 50-1.5 50-1.5s-10.5 5-16 6Z"
      fill="#8F8F8F"
      fillOpacity={0.39}
    />
    <path
      d="m33.056 71.299 18.8-2.8V34.78l-1.396-.112-17.297-.896-.107 22.627V71.3Z"
      fill="url(#s)"
    />
    <path
      d="M33.056 71.299 1.792 69.955l.323-35.734 11.817-.112 3.975-.112 15.256-.224-.107 37.526Z"
      fill="url(#t)"
    />
    <path
      d="m18.122 39.934-1.181-.672-1.182.56-.86-.112-.752.448-.215-6.049 3.975-.112.215 5.937Z"
      fill="#9F6B02"
    />
    <path
      d="M20.244 54.45a.478.478 0 0 1 .663.203l4.847 9.517a.524.524 0 0 1-.043.54.494.494 0 0 1-.491.204l-2.866-.538-.487 2.329a.513.513 0 0 1-.415.405.477.477 0 0 1-.502-.258l-4.847-9.518a.523.523 0 0 1 .21-.689l3.93-2.194Z"
      fill="#5067D0"
      stroke="#5067D0"
      strokeLinejoin="round"
    />
    <path
      d="M15.488 54.45a.478.478 0 0 0-.664.203L9.977 64.17a.524.524 0 0 0 .044.54.494.494 0 0 0 .49.204l2.866-.538.487 2.329c.044.21.21.372.416.405a.477.477 0 0 0 .502-.258l4.847-9.518a.524.524 0 0 0-.21-.689l-3.931-2.194Z"
      fill="#5067D0"
      stroke="#5067D0"
      strokeLinejoin="round"
    />
    <ellipse cx={18.21} cy={50.961} rx={8.353} ry={8.745} fill="#FD1980" />
    <ellipse cx={18.21} cy={50.961} rx={6.682} ry={6.996} fill="#FF8DB7" />
    <path
      d="M19.165 47.75a1 1 0 0 0-1.91 0l-.406 1.31h-1.287a1 1 0 0 0-.605 1.796l1.08.822-.418 1.345a1 1 0 0 0 1.56 1.092l1.031-.784 1.031.784a1 1 0 0 0 1.561-1.092l-.418-1.346 1.08-.82a1 1 0 0 0-.606-1.797h-1.286l-.407-1.31Z"
      fill="#F5C400"
      stroke="#F9A33D"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="s"
        x1={46.387}
        y1={71.071}
        x2={37.023}
        y2={31.144}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BD9610" />
        <stop offset={0.953} stopColor="#AC8639" />
        <stop offset={0.989} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="t"
        x1={-10.367}
        y1={23.308}
        x2={43.414}
        y2={74.104}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EFC639" />
        <stop offset={0.953} stopColor="#DEA531" />
        <stop offset={0.989} stopColor="#fff" />
      </linearGradient>
    </defs>
  </svg>
)

export default MatahariUang1
